import type { FC } from 'react';
import type { CardProps } from 'components/Card';
import Card from 'components/Card';
import TrimmedCardText from './TrimmedCardText';
import { StyledTrimmedCardContainer } from './styled';

const TrimmedCard: FC<{
  card: CardProps,
  isCollectedCollection?: boolean,
  listing?: boolean,
  listingsCount?: number,
  hideListing?: boolean,
  cardUrl?: string,
  collectionId?: string,
  price?: number,
}> = (
  {
    card,
    isCollectedCollection,
    listing,
    listingsCount = 0,
    hideListing = false,
    cardUrl,
    collectionId = '',
    price = 0,
  },
) => (
  <StyledTrimmedCardContainer>
    <Card
      card={card}
      cardUrl={cardUrl}
      collectionId={collectionId}
      isTrimmedCard
    />
    <TrimmedCardText
      card={card}
      price={price}
      isCollectedCollection={isCollectedCollection}
      listing={listing}
      listingsCount={listingsCount}
      hideListing={hideListing}
    />
  </StyledTrimmedCardContainer>
);

export default TrimmedCard;
